import { AssetOwnershipMeta } from '/@/modules/asset/models/meta/AssetOwnershipMeta';

export class BankAccountAssetMeta extends AssetOwnershipMeta {
  /**
   * @var {float}
   */
  interestRate;

  /**
   * @var {?number}
   */
  sharePercentage;

  constructor(model = {}) {
    super(model);

    this.interestRate = model.interestRate;
    this.sharePercentage = model.sharePercentage;
  }

  /**
   * @var {boolean}
   */
  get hasPercentShare() {
    return this.sharePercentage >= 0 && this.sharePercentage <= 100;
  }
}
